<template>
  <div class="login-page" v-if="pageType">
    <template v-if="pageType === 'h5'">
      <div class="activitybg" v-if="hashType === 'activity'">
        <img class="wrap-bg" src="@/assets/images/login_activitybg.png" alt="" />
      </div>
      <div v-else class="wrap">
        <img class="wrap-bg" src="@/assets/images/bg_wrap.png" alt="" />
        <img class="logo" src="@/assets/images/logo.png" alt="" />
      </div>
      <div :class="{ circlebox: hashType === 'activity' }"></div>
      <ul>
        <p class="label">
          <label for="mobile">手机号码</label>
        </p>
        <li>
          <p class="phone" @click="phoneAreaFn">
            <span>+{{ areaCode }}</span>
            <img class="sel" src="@/assets/images/icon_sel.png" alt="" />
          </p>
          <p class="ipt-phone">
            <input
              id="mobile"
              type="tel"
              maxlength="11"
              v-model="mobile"
              :disabled="lockPhone"
              @input="onChangePhone"
              @blur="onBlurPhone"
              :placeholder="placeholder"
            />
            <img
              class="clean-btn"
              v-if="mobile && !lockPhone"
              @click="onCleanPhone"
              src="@/assets/images/btn_cancel.png"
              alt=""
            />
          </p>
        </li>
        <p class="label">
          <label for="code">验证码</label>
        </p>
        <li>
          <p class="code">
            <input
              id="code"
              class="code_box"
              type="text"
              maxlength="4"
              v-model="captcha"
              @input="onChangeCode"
              @blur="onBlurCode"
              placeholder="请输入验证码"
            />
          </p>
          <p class="btn-box code_btn_box" @click="onGetCaptcha">
            <button :class="['btn', hasPhone ? 'bg' : '']" :disabled="!hasPhone">
              {{ captchaBtnText }}
            </button>
          </p>
        </li>
      </ul>
      <div class="login">
        <button class="confirm-btn" @click="login">登录</button>
        <p class="tip">
          登录即同意
          <span class="bg" @click="agreementFn">《友邻少年用户许可协议》</span>
        </p>
      </div>
      <div id="captcha"></div>
    </template>
    <template v-else>
      <div class="wrap-pc">
        <div class="login-bg-pc"></div>
        <div class="login-main-pc">
          <div class="login-box-pc">
            <div class="login-logo-pc">
              <img class="logo" src="@/assets/images/logo.png" alt="" />
            </div>
            <div class="login-title-pc">
              <div class="title">欢迎来到 友邻少年</div>
              <!-- <div class="title-commit">学无用的英文 做自由的灵魂</div> -->
            </div>
            <div class="login-form-pc">
              <ul>
                <p class="label">
                  <label for="mobile">手机号码</label>
                </p>
                <li>
                  <p class="phone" @click="phoneAreaFn">
                    <span>+{{ areaCode }}</span>
                    <img class="sel" src="@/assets/images/icon_sel.png" alt="" />
                  </p>
                  <p class="ipt-phone">
                    <input
                      id="mobile"
                      type="tel"
                      maxlength="11"
                      v-model="mobile"
                      :disabled="lockPhone"
                      @input="onChangePhone"
                      @blur="onBlurPhone"
                      :placeholder="placeholder"
                    />
                    <img
                      class="clean-btn"
                      v-if="mobile && !lockPhone"
                      @click="onCleanPhone"
                      src="@/assets/images/btn_cancel.png"
                      alt=""
                    />
                  </p>
                </li>
                <p class="label">
                  <label for="code">验证码</label>
                </p>
                <li>
                  <p class="code">
                    <input
                      id="code"
                      class="code_box"
                      type="text"
                      maxlength="4"
                      v-model="captcha"
                      @input="onChangeCode"
                      @blur="onBlurCode"
                      placeholder="请输入验证码"
                    />
                  </p>
                  <p class="btn-box code_btn_box" @click="onGetCaptcha">
                    <button :class="['btn', hasPhone ? 'bg' : '']" :disabled="!hasPhone">
                      {{ captchaBtnText }}
                    </button>
                  </p>
                </li>
              </ul>
              <div class="login">
                <button class="confirm-btn" @click="login">登录</button>
                <p class="tip">
                  登录即同意
                  <span class="bg" @click="agreementFn">《友邻少年用户许可协议》</span>
                </p>
              </div>
              <div id="captcha"></div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapGetters } from 'vuex'
import { appUser, storage, pageHashs, BehaviorCaptcha } from '@/utils'
import { getAccountId } from '@/utils/init/pubs'
var timer = null
export default {
  name: 'login',
  data() {
    return {
      captchaBtnText: '获取验证码',
      mobile: '',
      captcha: '',
      hasPhone: false,
      hasCode: false,
      areaCode: '86',
      placeholder: '请输入手机号',
      hashType: '',
      pageType: null //pc h5
    }
  },
  computed: {
    ...mapGetters('user/login', ['getWXUser', 'user', 'code']),
    // 提现类型
    lockPhone() {
      const { option } = this.$route.query
      return option === 'userWithdrawCash'
    }
  },
  activated() {
    this.areaCode = this.$route.params.code || '86'
    const { mobileNumber: mobile } = this.user
    if (this.lockPhone && mobile) {
      this.mobile = mobile
      this.onBlurPhone()
    }

    const hash = storage.loginNextHash().getItem()
    // 来自训练营的登录跳转调整提醒文案
    if (hash === 'string' && hash.indexOf('trainCamp') >= 0) {
      this.placeholder = '请输入APP内绑定的手机号'
    }
    //活动页面显示
    if (hash === 'string' && hash.indexOf('activity') >= 0) {
      this.hashType = 'activity'
    }
  },
  created() {
    if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i)) {
      console.log('移动端')
      this.pageType = 'h5'
    } else {
      this.pageType = 'pc'
      console.log('pc')
    }
  },
  mounted() {
    // // 来自训练营的登录跳转调整提醒文案
    // const hash = storage.loginNextHash().getItem()
    // if (hash === 'string' && hash.indexOf('trainCamp') >= 0) {
    //   this.placeholder = '请输入APP内绑定的手机号'
    // }
    // end
    // 注册行为验证码
    BehaviorCaptcha.create({
      onpass: this.sendCaptcha
    })
  },
  methods: {
    phoneAreaFn() {
      this.$router.push({
        name: 'phone-area',
        params: {
          code: this.areaCode
        }
      })
    },
    agreementFn() {
      location.href = '/static/userAgreement.html'
    },
    onCleanPhone() {
      this.mobile = ''
    },
    onChangePhone() {
      this.hasPhone = false
      this.hasCode = false
      const isChina = parseInt(this.areaCode) === 86
      if (isChina ? this.mobile.length === 11 : true) {
        this.onBlurPhone()
      }
    },
    onBlurPhone() {
      const isChina = parseInt(this.areaCode) === 86
      if (isChina) {
        const reg = /^1[0-9]{10}$/.test(this.mobile)
        if (!reg) {
          Toast('请输入正确的手机号')
          this.hasPhone = false
        } else {
          this.hasPhone = true
        }
      } else {
        this.hasPhone = true
      }
    },
    onChangeCode() {
      this.hasCode = false
      if (this.mobile.length === 4) {
        this.onBlurCode()
      }
    },
    onBlurCode() {
      const reg = /^[0-9]{4}$/.test(this.captcha)
      if (!reg) {
        Toast('请输入验证码')
        this.hasCode = false
      } else {
        this.hasCode = true
      }
    },
    setTimer() {
      let s = 60
      this.isWating = true
      timer = window.setInterval(() => {
        this.captchaBtnText = --s + 's后重试'
        // this.hasPhone = false;
        if (s === 0) {
          this.hasPhone = true
          window.clearInterval(timer)
          this.isWating = false
          this.captchaBtnText = '重新获取'
        }
      }, 1000)
    },
    // 显示行为验证码
    onGetCaptcha() {
      if (this.isWating) {
        return
      }
      // 暂时跳过
      // this.sendCaptcha({ ret: 0 })
      BehaviorCaptcha.show() // 显示验证码
    },
    // 发送验证码（并接受验证码的批次ID）
    sendCaptcha(res) {
      // 发送提示
      this.captchaBtnText = '60s后重试'
      this.captchaRes = res
      this.setTimer()

      const { ticket, randstr: randStr } = this.captchaRes || {}
      if (!ticket) return
      const { option } = this.$route.query
      // 获取验证码
      const params = {
        mobileNumber: this.mobile,
        areaCode: this.areaCode,
        wxUnionId: appUser.unionId,
        wxOpenId: appUser.openId,
        option: option || 'toLogin',
        ticket,
        randStr // 行为验证码的结果
      }
      const action = this.$store.dispatch('user/login/getCode', params).then(res => {
        // 测试账号自动登录
        if (this.captcha === '9989') {
          this.login()
        }
      })
      if (action == null) {
        Toast('发送验证码失败，login.getCode 未定义')
      }
    },
    resetData() {
      window.clearInterval(timer)
      this.captchaBtnText = '获取验证码'
      this.mobile = ''
      this.captcha = ''
      this.hasPhone = false
      this.hasCode = false
      this.isWating = false
      this.areaCode = '86'
    },
    login() {
      const { batchID } = this.code
      if (!this.captchaRes || !this.captchaRes.ticket) {
        return this.$toast('请先输入验证码')
      }
      const { ticket, randstr: randStr } = this.captchaRes
      const params = {
        mobileNumber: this.mobile,
        areaCode: this.areaCode,
        verificationCode: this.captcha,
        batchID, // 验证码发生成功后获得
        wxUnionId: appUser.unionId,
        wxOpenId: appUser.openId,
        option: 'toLogin',
        // ticket,
        isBrowser: appUser.isBrowser,
        accountId: getAccountId(appUser.isBrowser)
        // randStr // 行为验证码的结果
      }
      if (!this.hasPhone) {
        return Toast('请输入手机号')
      }
      if (!this.hasCode) {
        return Toast('请输入验证码')
      }
      if (!batchID) {
        return Toast('请稍后重试')
      }
      if (params.isBrowser) {
        // 浏览器登录去掉wx相关字段
        delete params.wxUnionId
        delete params.wxOpenId
      }
      const checkCode = this.$store.dispatch('user/login/checkCode', params)
      // 验证后立即清除验证码
      this.captcha = ''
      checkCode
        .then(data => {
          if (data.token) {
            this.resetData()
            data.userId = data.userModel.userID
            appUser.setAppUser(data).then(_ => {
              // 微信内需要切换手机号时的标记，登录成功后清除
              storage.AppUserKeySwitch().remove()
              // 跳转到登录前访问的业务
              let hash = storage.loginNextHash().getItem()
              if (hash == null) {
                hash = pageHashs.home
              }
              // 指定登录后打开的业务
              if (hash instanceof Object) {
                const { to } = this.$route.query
                if (to) hash = to
                else hash = 'userinfo' // 登录之后去哪里
              }
              // 确认订单页过来的 跳回商品落地页,防止不必要的抵扣问题
              if (hash.indexOf('confirm-order') >= 0) hash = 'goods'

              // 延迟进入页面
              this.$router.replace({ path: hash })
            })
          } else {
            Toast('验证码无效')
            // 清除验证码
            this.captcha = ''
          }
        })
        .catch(error => {
          console.log('login-Error--------', error)
          // 处理多账号合并
          if (error.code === 10026 || error.code === 10027) {
            this.$router.push({
              path: '/mergeAcount',
              query: {
                changeCode: error.data.changeCode
              }
            })
          }
        })
    }
  }
}
</script>
<style lang="less" scoped>
.code_box,
.code_btn_box {
  line-height: 1.2;
}
.login-page {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .activitybg {
    img {
      width: 100%;
    }
  }
  .circlebox {
    position: relative;
    background: #fff;
    height: 20px;
    border-radius: 16px;
    margin-top: -12px;
    margin-bottom: -20px;
  }
  .wrap {
    display: flex;
    justify-content: center;
    position: relative;
    .wrap-bg {
      width: 3.6rem;
      height: 3.8rem;
      position: absolute;
      top: 0;
      right: 0;
    }
    .logo {
      width: 1.2rem;
      height: 1.2rem;
      margin-top: 1.61rem;
    }
  }

  ul {
    width: 100%;
    padding: 0 0.64rem;
    margin-top: 0.36rem;
    display: flex;
    flex-direction: column;
    > p {
      color: #333333;
      font-size: 0.24rem;
      font-weight: 500;
      margin: 0.64rem 0 0.17rem;
      &.label {
        text-align: left;
      }
    }
    li {
      padding: 0.18rem 0;
      display: flex;
      border-bottom: 0.02rem solid #dddddd;
      font-size: 0.28rem;
      &:nth-child(4) {
        justify-content: space-between;
      }
      input {
        width: auto;
        border: none;
        outline: none;
        width: 2rem;
        -webkit-user-select: auto !important;
        caret-color: #000000;
        font-size: 0.28rem;
        width: 100%;
      }
      input[type='tel']::-ms-clear {
        display: none;
        width: 0;
        height: 0;
      }
      input[type='tel']::-ms-reveal {
        display: none;
        width: 0;
        height: 0;
      }
      input::-webkit-input-placeholder {
        color: #999999;
      }
      .ipt-phone {
        line-height: 1.2;
        padding-left: 0.4rem;
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .clean-btn {
          width: 0.32rem;
          height: 0.32rem;
        }
      }
      .phone {
        padding-right: 0.4rem;
        border-right: 1px solid #dddddd;
        .sel {
          width: 0.1rem;
          height: 0.1rem;
          margin-left: 0.08rem;
        }
        .number {
          font-size: 0.32rem;
          color: #333333;
        }
      }
      .btn-box {
        padding-left: 0.4rem;
        border-left: 1px solid #dddddd;
        .btn {
          border: none;
          background-color: #fff;
          color: #999999;
          &.bg {
            color: #00b25a;
          }
        }
      }
    }
  }
  .login {
    padding: 0 0.64rem;
    margin-top: 0.64rem;
  }
  .confirm-btn {
    width: 100%;
    padding: 0.24rem 0;
    background-color: #eeeeee;
    font-size: 0.32rem;
    line-height: 0.4rem;
    border-radius: 0.12rem;
    color: #ffffff;
    background-color: #00b25a;
  }
  .tip {
    margin-top: 0.32rem;
    text-align: center;
    font-size: 0.24rem;
    color: #999999;
    .bg {
      color: #00b25a;
    }
  }
}
.pop_box {
  font-size: 0.28rem;
  font-weight: 800;
  justify-content: center;
  flex-direction: column;
  padding: 0.4rem 0 0.32rem;
  img {
    display: block;
    width: 2.6rem;
    height: 2.6rem;
    margin-bottom: 0.2rem;
  }
}

.wrap-pc {
  height: 100%;
  display: flex;
  .login-bg-pc {
    height: 100%;
    flex: 1;
    background: url('../../../../assets/images/login_bg.jpg') no-repeat center;
    background-size: cover;
  }
  .login-main-pc {
    background: #fff url('../../../../assets/images/login_box_bg.png') no-repeat;
    background-size: 100% 100%;
    // float: right;
    width: 800px;
    max-width: 660px;
    min-width: 450px;
    height: 100%;
    padding: 0 20px;

    .login-box-pc {
      max-width: 450px;
      width: 80%;
      min-width: 400px;
      background: #ffffff;
      box-shadow: 0px 0px 20px rgba(38, 88, 89, 0.1);
      border-radius: 16px;
      padding: 64px;
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      .login-logo-pc {
        margin-bottom: 24px;
        .logo {
          width: 64px;
          height: 64px;
        }
      }
      .login-title-pc {
        .title {
          font-weight: 600;
          font-size: 24px;
          line-height: 34px;
          color: #3f3f3f;
          margin-bottom: 4px;
        }
        .title-commit {
          font-weight: 400;
          font-size: 16px;
          color: #939393;
        }
      }
      .login-form-pc {
        ul {
          width: 100%;
          padding: 0;
          margin-top: 24px;
          display: flex;
          flex-direction: column;
          > p {
            color: #333333;
            font-size: 14px;
            font-weight: 500;
            margin: 32px 0 8px;
            &.label {
              text-align: left;
            }
          }
          li {
            padding: 9px 0;
            display: flex;
            border-bottom: 1px solid #dddddd;
            font-size: 14px;
            &:nth-child(4) {
              justify-content: space-between;
            }
            input {
              width: auto;
              border: none;
              outline: none;
              width: 1px;
              -webkit-user-select: auto !important;
              caret-color: #000000;
              font-size: 14px;
              width: 100%;
            }
            input[type='tel']::-ms-clear {
              display: none;
              width: 0;
              height: 0;
            }
            input[type='tel']::-ms-reveal {
              display: none;
              width: 0;
              height: 0;
            }
            input::-webkit-input-placeholder {
              color: #999999;
            }
            .ipt-phone {
              line-height: 1.2;
              padding-left: 2px;
              flex: 1;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .clean-btn {
                width: 16px;
                height: 16px;
              }
            }
            .phone {
              padding-right: 2px;
              border-right: 1px solid #dddddd;
              .sel {
                width: 1px;
                height: 1px;
                margin-left: 4px;
              }
              .number {
                font-size: 16px;
                color: #333333;
              }
            }
            .btn-box {
              padding-left: 2px;
              border-left: 1px solid #dddddd;
              .btn {
                border: none;
                background-color: #fff;
                color: #999999;
                &.bg {
                  color: #00b25a;
                }
              }
            }
          }
        }
        .login {
          padding: 0;
          margin-top: 56px;
          .tip {
            margin-top: 16px;
            text-align: center;
            font-size: 12px;
            color: #999999;
            .bg {
              color: #00b25a;
            }
          }
        }
        .confirm-btn {
          width: 100%;
          padding: 12px 0;
          background-color: #eeeeee;
          font-size: 16px;
          line-height: 20px;
          color: #ffffff;
          background-color: #00b25a;
          box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07), 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198),
            0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275), 0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035),
            0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
          border-radius: 5px;
        }
      }
    }
  }
}
</style>
